<!--  -->
<template>
  <div class="dsawr">
    <div style="margin-bottom:20px" class="search_box">
      <!-- <el-input v-model="pageIfon.open_id" placeholder="请输入openid" style="width:200px;margin-right:10px" />
      <el-input v-model="pageIfon.app_id" placeholder="请输入公众号appid" style="width:200px;margin-right:10px" />
      <el-input v-model="pageIfon.mch_bill_no" placeholder="请输入商户号id" style="width:200px;margin-right:10px" /> -->
      <el-input v-model="pageIfon.keywords" placeholder="请输入openid/appid/商户号id" style="width:230px;margin-right:10px" />
      <el-date-picker
        v-model="pageIfon.created_at"
        format="yyyy-MM-dd"
        value-format="yyyy-MM-dd"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="margin-right:10px"
      />
      <el-button type="primary" icon="el-icon-search" @click="serawed">搜索</el-button>
      <el-button type="info" icon="el-icon-refresh" @click="daskdw">重置</el-button>
      <el-button type="success" icon="el-icon-download" @click="exportlisrwdaw">导出</el-button>
    </div>

    <el-table
      :data="tableData"
      border
      style="width: 100%"
    >
      <el-table-column
        prop="id"
        label="Id"
        width="80"
        align="center"
      />
      <el-table-column
        prop="app_id_text"
        label="公众号名称"
        align="center"
      />
      <el-table-column
        prop="app_id"
        label="公众号appid"
        width="180"
        align="center"
      />
      <el-table-column
        prop="open_id"
        label="open_id"
        width="180"
        align="center"
      />
      <el-table-column
        prop="mch_bill_no"
        label="商户号"
        width="180"
        align="center"
      />
      <el-table-column
        prop="total_amount_text"
        label="红包金额"
        width="80"
        align="center"
      />
      <el-table-column
        prop="receive_status"
        label="领取状态"
        align="center"
      >
        <template slot-scope="scope">
          <i v-if="scope.row.receive_status_int == 1" class="el-icon-warning" />
          <i v-if="scope.row.receive_status_int == 2" class="el-icon-warning fasrw" />
          <i v-if="scope.row.receive_status_int == 3" class="el-icon-warning defaultrse" />
          <i v-if="scope.row.receive_status_int == 4" class="el-icon-close stopew" />
          <i v-if="scope.row.receive_status_int == 5" class="el-icon-success defaultr" />
          <i v-if="scope.row.receive_status_int == 6" class="el-icon-money defaultrse" />
          <i v-if="scope.row.receive_status_int == 7" class="el-icon-money stopew" />
          <i v-if="scope.row.receive_status_int == 9" class="el-icon-delete-solid stopew" />
          <div>{{ scope.row.receive_status }}</div>
          <!-- self::STATUS_1 => "生成记录待发出",
                self::STATUS_2 => "发放中",
                self::STATUS_3 => "已发放待领取",
                self::STATUS_4 => "发放失败",
                self::STATUS_5 => "已领取",
                self::STATUS_6 => "退款中",
                self::STATUS_7 => "已退款",
                self::STATUS_9 => "删除", -->
        </template>
      </el-table-column>
      <el-table-column
        prop="receive_time_text"
        label="领取时间"
        width="180"
        align="center"
      />

      <el-table-column
        prop="creator"
        label="创建人"
        align="center"
      />
      <el-table-column
        prop="creator"
        label="二维码"
        align="center"
      >
        <template slot-scope="scope">
          <img v-if="scope.row.link_pic" :src="scope.row.link_pic" alt="" style="width:80px;height:100px">
        </template>
      </el-table-column>
      <el-table-column
        prop="created_at_text"
        label="创建时间"
        align="center"
      />

      <el-table-column
        prop="creator"
        label="操作"
        align="center"
      >
        <template slot-scope="scope">
          <el-button v-if="scope.row.link_pic!=''" size="mini" type="warning" style="margin-bottom:10px" @click="weweimaclick(scope.row.link_pic)">预览二维码</el-button>
          <!-- <el-button size="mini" type="primary" @click="weweimaclickwew(scope.row)">生成二维码</el-button> -->
          <!-- <el-button size="mini" type="primary" @click="exportlisrwdaw(scope.row)">导出</el-button> -->
        </template>
      </el-table-column>
    </el-table>
    <pagination-right
      :total="total"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />
    <el-dialog
      title="预览"
      :visible.sync="dialogVisible"
      width="30%"
    >
      <cashdialog ref="lookecahrtimg" />
    </el-dialog>
    <el-dialog
      title="生成二维码"
      :visible.sync="dialogVisibler"
      width="30%"
    >
      <generate ref="lookecahrtimgrw" @callback="callback" />
    </el-dialog>
  </div>
</template>

<script>
import PaginationRight from '@/components/PaginationRight/index.vue'
import cashdialog from './components/cashdialog.vue'
import generate from './components/generate.vue'
import { usercachback, exportListrw } from '@/api/officialaccount.js'
export default {
  name: 'Cashback',
  components: {
    PaginationRight,
    cashdialog,
    generate
  },
  data() {
    return {
      tableData: [],
      total: null,
      pageIfon: {
        page: 1,
        pageSize: 10,
        // open_id: null,
        // app_id: null,
        // mch_bill_no: null
        keywords: null,
        created_at: []
      },
      dialogVisible: false,
      dialogVisibler: false
    }
  },
  created() {
    this.exchangedata()
  },
  mounted() {

  },
  methods: {
    async exchangedata() {
      const data = await usercachback(this.pageIfon)
      this.tableData = data.data.list
      this.total = data.data.total
      console.log('data', data)
    },
    weweimaclick(img) {
      this.dialogVisible = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.lookecahrtimg.send(img)
      })
    },
    // 分页
    fetchPageSize(e) {
      this.pageIfon.pageSize = e
      this.exchangedata()
    },
    fetchCurrentPage(e) {
      this.pageIfon.page = e
      this.exchangedata()
    },
    weweimaclickwew(item) {
      this.dialogVisibler = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.lookecahrtimgrw.sendr(item)
      })
    },
    callback(img) {
      this.dialogVisibler = false
      this.dialogVisible = true
      this.$nextTick(() => { // 请求成功之后，在这里执行
        this.$refs.lookecahrtimg.send(img)
      })
      this.exchangedata()
    },
    async exportlisrwdaw() {
      this.$confirm('确定要导出吗？ 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        console.log('666')
        exportListrw({
          // open_id: this.pageIfon.open_id,
          // app_id: this.pageIfon.app_id,
          // mch_bill_no: this.pageIfon.mch_bill_no,
          keywords: this.pageIfon.keywords,
          created_at: this.pageIfon.created_at
        }).then((res) => {
          console.log('res', res)
          this.$message({
            type: 'success',
            message: '导出成功!'
          })
          window.open(res.data.data, '_blank')
        })
      }).catch(() => {
        // this.$message({
        //   type: 'info',
        //   message: '已取消删除'
        // })
      })
    },
    serawed() {
      this.pageIfon.page = 1
      this.exchangedata()
    },
    daskdw() {
      this.pageIfon.page = 1
      this.pageIfon.pageSize = 10
      // this.pageIfon.open_id = null
      // this.pageIfon.app_id = null
      // this.pageIfon.mch_bill_no = null
      this.pageIfon.keywords = null
      this.pageIfon.created_at = []
      this.exchangedata()
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */
.dsawr{
  padding: 20px;
}
.defaultrse{
  color: #E6A23C;
}
.defaultr{
  color: #67C23A;
}
.stopew{
  color: red;
}
.fasrw{
  color: #409EFF;
}
</style>
